module.exports = __webpack_public_path__ + "img/DIHS_Silhoutten_Anamnese_03082020.2f324b00.jpg";